import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { SiteContext } from '../../../context/SiteContext';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import NeedHelpPage from './NeedHelpPage';

type InsuranceErrorPageProps = {
  error: Error;
  resetErrorBoundary: () => void;
};

const InsuranceErrorPage = ({
  error,
  resetErrorBoundary
}: InsuranceErrorPageProps): JSX.Element => {
  const { site } = useContext(SiteContext);
  const navigate = useNavigate();
  const brandPhoneNumber =
    site.brand?.brandPhoneNumbers?.quotesAndRenewalsNumber ?? '';

  const onHomeClick = () => {
    const redirect = site.user.isDealer
      ? PageAbsolutePath.Insurance.DealerLandingPage
      : PageAbsolutePath.Insurance.Landing;
    navigate(redirect);
    resetErrorBoundary();
  };

  useEffect(() => {
    console.error(`Insurance error: ${error.message}`);
  }, []);

  return (
    <div className='ancillary-page'>
      <div className='flex-row ancillary-main'>
        <div className='flex-column left-column'>
          <NeedHelpPage
            showCallMeBackButton={false}
            showCallYouBackHeading={false}
          />
        </div>
        <div className='flex-column right-column'>
          <h3>An error has occurred.</h3>
          <p>{`Please click 'Try Again' or 'Home' to start again. Alternatively, please contact us on ${brandPhoneNumber}.`}</p>
          <div className='flex-row form-nav'>
            <ButtonBack
              name='btn-back'
              text='Home'
              onClick={() => onHomeClick()}
              additionalClassNames='btn-back'
            />
            <ButtonContinue
              name='btn-continue'
              text='Try Again'
              onClick={resetErrorBoundary}
              additionalClassNames='btn-continue'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceErrorPage;
